module.exports = __webpack_public_path__ + "static/media/syringe.e4531cb6.svg";